import { useState } from "react";
import { MapPin } from "lucide-react";

export const KnownSiteCard = ({ site, more = 0, attached, onAttach, onDetach }) => {
  const [reveal, setReveal] = useState(false);
  return (
    <div className={`known-site fade-up ${attached ? "" : "known-site-off"}`} data-testid="known-site-card" data-attached={attached ? "true" : "false"}>
      <p className="eyebrow flex items-center gap-1"><MapPin size={12} /> {attached ? "Known site attached" : "Known site nearby"}{more > 0 && <span className="text-muted">· +{more} more</span>}</p>
      <p className="font-bold mt-1" data-testid="known-site-title">{site.title} · {Math.round(site.distance_m)}m away</p>
      {site.hazards?.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2" data-testid="known-site-hazards">
          {site.hazards.map((h, i) => <span key={i} className="chip chip-yellow">⚠ {h}</span>)}
        </div>
      )}
      {site.access_notes && <p className="text-sm text-muted mt-2" data-testid="known-site-notes">{site.access_notes}</p>}
      {site.access_code_masked && (
        <button type="button" data-testid="known-site-code" className="code-reveal mt-2" onClick={() => setReveal(!reveal)}>
          {reveal ? site.access_code_masked : "••••••••"} <span className="text-xs text-muted ml-2">{reveal ? "Hide" : "Tap to reveal"}</span>
        </button>
      )}
      {attached ? (
        <button type="button" data-testid="different-site-button" className="text-sm text-muted mt-3 underline-offset-4 hover:underline" onClick={onDetach}>This is a different site</button>
      ) : (
        <button type="button" data-testid="use-site-button" className="btn-secondary mt-3" onClick={() => onAttach(site)}>Use this site</button>
      )}
    </div>
  );
};
